import React, { Component, createRef, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {setNotice} from '../../actions';
import {Api} from '../../util';

import CheckBox from '../checkbox';

const modalRoot = document.getElementById('root');

class UserDelPwd extends Component {
	constructor(props){
		super(props);
		this.state = {
      oldPwd: ""
    };
    
    this.oldPwdRef = createRef();

    this.handleOldPwd = this.handleOldPwd.bind(this);
    this.handleUserDel = this.handleUserDel.bind(this);
	}

  handleOldPwd(e){
    this.setState({
      oldPwd: e.target.value
    })
  }


  // 사용자 삭제
  async DelUser(cmdData){
    try{
        await this.props.loadingToggle(true);
        await Api.DeleteUser({...cmdData});
        await this.props.setNotice(true, 'success', "사용자를 삭제하였습니다");
        await this.props.SearchUser();
    } catch(e) {
      await this.props.setNotice(true, 'fail', '사용자 정보를 삭제하는데 실패하였습니다');
    } finally{
      await this.props.loadingToggle(false);
    }
  }

    // 사용자 정보 저장
    handleUserDel(){
      const { oldPwd } = this.state;
      const {userId} = this.props;
      const cmdData = {
        LOGIN_ID: sessionStorage.getItem("id"),
        LOGIN_PWD: oldPwd,
        ID: userId,
      };
      let checkSave = false;
      switch(sessionStorage.getItem("auth")){
        case "A":
        case "M":
          checkSave=true;
          break;
        default:
          checkSave=false;
          break;
      }
      
      if(checkSave){
        if(oldPwd === ""){
          this.props.setNotice(true, "fail", `${sessionStorage.getItem('name')}의 비밀번호를 입력해주세요`);
          this.oldPwdRef.focus();
          return false;
        }else{
          this.DelUser(cmdData);
          this.props.handleDelHide();
        }
      }else{
        this.props.setNotice(true, "fail", "잘못된 접근입니다.");
      }
    }

	render() {
        const {
       
            oldPwd,

        } = this.state;
        const {
          handleDelHide
        } = this.props;



		return ReactDOM.createPortal(
			<div id="modal-wrap">
        <div className = "modal user-container delete-popup">
          <div className="header">
            <div>사용자 삭제</div>
            <div onClick={handleDelHide}>
              <span className="icon modal-close"></span>
            </div>
          </div>

          <div className="detail-wrapper">
            <div className="content-item-group">
            
               
                <div className="content-item">
                  <div className="caption">
                    {`${sessionStorage.getItem('name')}의 비밀번호`}
                  </div>
                  <div className="value">
                    <input type="password" value={oldPwd} onChange={this.handleOldPwd} ref={i => this.oldPwdRef = i } />
                  </div>
                </div>

              </div>
            </div>
            
            <div className="footer">
              <button type="button" onClick={this.handleUserDel}>저 장</button>
              <button type="button" onClick={handleDelHide}>닫 기</button>
            </div>

        </div>
			</div>
		, modalRoot);
	}
}



const mapDispatcherToProps = dispatch => {
    return {
        setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
        
    }
  };
  
UserDelPwd = connect(undefined,mapDispatcherToProps)(UserDelPwd);
  

export default UserDelPwd;


// WEBPACK FOOTER //
// ./src/components/modal/UserDelPwd.js